<app-modal #modal></app-modal>
<div *ngFor="let section of sections">
  <h3>{{ section.title }}</h3>

  <div *ngIf="section.body">
    <div class="xml-accordion">
      <details class="p-2">
        <summary class="underline xmlModal" [title]="section.body.split('::')[1]">
          {{ section.body.split('::')[0] }}
        </summary>
      </details>
    </div>
  </div>
</div>
